import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  mono?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ mono, className = '', ...rest }, ref) => (
  <input ref={ref} className={`input ${mono ? 'input--mono' : ''} ${className}`.trim()} {...rest} />
))
Input.displayName = 'Input'

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement> & { mono?: boolean }>(
  ({ mono, className = '', ...rest }, ref) => (
    <textarea ref={ref} className={`textarea ${mono ? 'input--mono' : ''} ${className}`.trim()} {...rest} />
  )
)
Textarea.displayName = 'Textarea'

export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className = '', children, ...rest }, ref) => (
    <select ref={ref} className={`select ${className}`.trim()} {...rest}>{children}</select>
  )
)
Select.displayName = 'Select'

export default Input
